import React from 'react';
import {
  Flex, Popover, Tooltip, Typography,
} from 'antd';
import styled from 'styled-components';
import { MailOutlined } from '@ant-design/icons';
import { colors, fonts } from '../assets/constStyles';

const { Link } = Typography;

interface PhotographerInfoProps {
  year?: string
}

const AStyled = styled.a`
  font-family: ${fonts.font2};
  cursor: pointer;
  font-size: 1.3em;
  text-decoration: underline;
  color: ${colors.colorMutedGreen};
  

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
    color: ${colors.colorTextDark};
  }
`;

const PhotographerInfo: React.FC<PhotographerInfoProps> = ({ year }) => {
  const handleAddContact = () => {
    const vcardData = `
            BEGIN:VCARD
            VERSION:3.0
            FN:Max Hil
            ORG:Photographer
            EMAIL:photo.hilco@gmail.com
            END:VCARD
                `.trim();

    const blob = new Blob([vcardData], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'Max_Hil_Photographer.vcf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return year === '2025' ? (
      <Flex vertical gap={4}>
          <Popover
              trigger="click"
              placement="bottomLeft"
              content={
                  <Flex vertical gap={8} >
                      <Flex align={'center'}>
                          <MailOutlined style={{ fontSize: 14, marginRight: 5 }} />
                          <span>hilco.photo@gmail.com</span>
                      </Flex>
                      <Link onClick={handleAddContact} data-gtm="add-to-contacts-photo">Add to contacts</Link>
                  </Flex>
              }
          >
              <Tooltip title="Click here to view contact info">
                <AStyled data-gtm="photographer-contact">Photographer: Max Hil</AStyled>
              </Tooltip>
          </Popover>
      </Flex>
  ) : null;
};

export default PhotographerInfo;
